const languageData = [
  {
    languageId: "persian",
    locale: "fa",
    name: "فارسی",
    icon: "ir",
    direction: "rtl",
  },
  {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
    direction: "ltr",
  },
];
export default languageData;
